(() => {
  'use strict';

  const property = '--aapka-product-sticky-top';
  const gap = 16;

  function getHeader() {
    return (
      document.querySelector('.section-header.aapka-header-section') ||
      document.querySelector('.section-header')
    );
  }

  function updateOffset() {
    const header = getHeader();

    if (!header) {
      document.documentElement.style.setProperty(property, `${gap}px`);
      return;
    }

    const style = window.getComputedStyle(header);

    const isSticky =
      style.position === 'sticky' ||
      style.position === 'fixed' ||
      header.classList.contains('shopify-section-header-sticky');

    const height = isSticky
      ? Math.ceil(header.getBoundingClientRect().height)
      : 0;

    document.documentElement.style.setProperty(
      property,
      `${height + gap}px`
    );
  }

  function init() {
    updateOffset();

    const header = getHeader();

    if (header && 'ResizeObserver' in window) {
      const observer = new ResizeObserver(updateOffset);
      observer.observe(header);
    }

    window.addEventListener('resize', updateOffset, {
      passive: true
    });

    window.addEventListener('orientationchange', updateOffset, {
      passive: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();